<template>
    <div class="page-action-list" v-show="isMounted">
        <div class="common-wrap">
            <div class="paeparation">
                <div class="search">
                    <el-input class="ipt" clearable size="large" v-model="queryParam.modelName"
                              placeholder="请输入关键词用空格隔开"></el-input>
                    <div class="btn">
                        <i class="el-icon-search" @click="changePage(1)">搜索</i>
                    </div>
                </div>
                <div class="types-list">

                  <a href="http://i.renrendonghua.com/source/audio/edit?belongSection=3" class="upload-source" target="_blank">
                    <el-button type="danger" size="mini">上传素材</el-button>
                  </a>

                    <div class="type-item clearfix">
                        <div class="tit">素材分类：</div>
                        <ul class="cases clearfix">
                            <a :href="baseUrl+'/model?plate=3'"><li >模型库</li></a>
                            <a :href="baseUrl+'/action?plate=3'"><li >动作库</li></a>
                            <a :href="baseUrl+'/audio?plate=3'"><li class="active">音效库</li></a>
                        </ul>
                    </div>
                    <div class="type-item clearfix">
                        <div class="tit">类别：</div>
                        <ul class="cases clearfix">
                            <template v-for="(item, index) in firstDicts">
                                <li :key="index" v-if="queryParam.modelType == item.id" class="active"
                                    @click="selectDict(item)">
                                    {{item.dicName}}
                                </li>
                                <li :key="index" @click="selectDict(item)" v-else>{{item.dicName}}</li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="paeparation-result clearfix" v-if="newModelPage.total>0" >
                <a target="_blank" :href="baseUrl+'/audio/detail?id='+item.id+'&plate=3'" class="audio-item-one clearfix"
                             v-for="(item, index) in newModelPage.list" :key="index">
                    <img class="left-img" :src="require('@/assets/images/audio_img.png')" alt="">
                    <div class="right-info">
                        <div class="tit ell" :title="item.modelName">{{item.modelName}}</div>
                        <div class="foss clearfix">
                            <div class="geshi ell" v-if="item.formatStr && item.formatStr.length>2">
                                格式：{{item.formatStr.substr(1,item.formatStr.length-2)}}
                            </div>
                            <div class="price" v-if="item.modelPrice>0">￥{{item.modelPrice}}</div>
                            <div class="price" v-else>免费</div>
                        </div>
                    </div>
                </a>
            </div>
            <div v-else class="common-no-data">
                <img class="img" :src="emptyImg" alt="">
                <!--                    <span class="words">抱歉！您访问的页面暂无数据</span>-->
            </div>

            <div class="pagintion-f" v-if="isMounted && newModelPage.total>0">
                <el-pagination
                        background
                        @current-change="changePage"
                        layout="prev, pager, next,jumper"
                        :current-page="queryParam.pageIndex"
                        :page-size="queryParam.pageSize"
                        :total="newModelPage.total"
                        :hide-on-single-page="true"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import updateTdk from "@/utils/tdk";
    import axios from 'axios';
    import vue from 'vue';
    import modelApi from '@/api/model'
    import { mapState } from 'vuex'

    vue.prototype.$axios = axios;
    export default {
        components: {},
        computed: {
            ...mapState(['newModelPage']),
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },
        serverPrefetch() {
            this.fetchData()
            return this.initData();
        },
        mounted() {
            this.fetchData()
            this.initData().then(()=>{
                this.fetchDataMounted()
            })

        },

        data() {
            return {
                baseUrl:process.env.config.RRDH_HOST,
                headTitle: "title---rrdh",
                headKeywords: "keywords---rrdh",
                headDesc: "description---rrdh",
                isMounted: false, //for control not ssr render
                firstDicts: [],
                queryParam: {
                    modelName: '',
                    modelType: 0,
                    materialSort: 2,
                    pageIndex: 1,
                    pageSize: 12,
                },
                listLoading: true,
                tableData: [],
                total: 0,
                emptyImg: require('@/assets/images/empty.png'),
            }
        },
        methods: {
            fetchData(){
                let plate = this.$route.query.plate
                this.plate = plate
                let paramPageIndex = this.$route.query.toPageNum
                if(!paramPageIndex){
                    paramPageIndex = 1
                }
                this.queryParam.pageIndex =Number(paramPageIndex)
                let modelType = this.$route.query.modelType
                let modelName = this.$route.query.modelName
                if(modelName){
                    this.queryParam.modelName = modelName
                }
                if(modelType){
                    this.queryParam.modelType = modelType
                }
            },
            fetchDataMounted(){
                setTimeout(()=>{
                    this.isMounted = true;
                    this.getDictsForType(6)
                },1000)
            },
            initData(){
                this.$loading(true)
                const cookies = this.$ssrContext && this.$ssrContext.cookies
                return this.$store.dispatch("FETCH_NEW_MODEL_PAGE", {params: this.queryParam,cookies:cookies}).finally(() => {
                    this.$loading(false)
                    this.setSeo();
                    updateTdk.call(this);
                })
            },
            changePage(page){
                let urlNow=window.location.href

                if(urlNow.indexOf("toPageNum") > 0){
                    urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))
                }
                let url = urlNow +"&toPageNum="+page
                if(this.queryParam.modelName){
                    url += "&modelName="+this.queryParam.modelName
                }
                if(this.queryParam.modelType){
                    url += "&modelType="+this.queryParam.modelType
                }
                window.location.href= url
            },
          setSeo() {
            this.headTitle = "音效库——人人动画网【官网】";
            this.headKeywords = "模型库,人物模型，建筑模型，场景模型，动物模型";
            this.headDesc = "为创作者提供海量音效包,游戏音效,影视音效,声音,特效,实用等音效素材";
          },
            getDictsForType(type) {
                let _this = this;
                let url = '/rrbi/model/getDictsForType/' + type
                _this.$axios.get(url).then(function (result) {
                    let all = {'id': 0, 'dicName': '全部'}
                    _this.firstDicts.push(all)
                    result.data.response.forEach((item, index) => {
                        _this.firstDicts.push(item)
                    })
                })
            },
            selectDict(item) {
                this.queryParam.modelType = item.id
                this.changePage(1)
            },
            search(page) {
                console.log(page)
                let this_ = this
                if (!page) {
                    page = 1
                }
                this_.listLoading = true
                this.queryParam.pageIndex = page
                console.log("this_.queryParam=================", this_.queryParam)
                modelApi.pageList(this_.queryParam).then(data => {
                    this_.tableData = data.response.list
                    this_.total = data.response.total
                    this_.listLoading = false
                })
              this.setSeo();
              updateTdk.call(this);
            },
        }
    }
</script>

<style scoped lang="less">
    .page-action-list {
        padding-top: @NAVHEIGHT;
    }

    .pagintion-f {
        padding: 20px 0 40px;
        text-align: center;
    }

    //@import "../../../../assets/less/stylePublic.less";
</style>
